<template>
  <div>
    <div class="row">
      <div class="col-12 text-muted">
        <p>{{ heading }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <slot name="info-slot">
          <p>{{ info }}</p>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileRow",
  props: {
    heading: {
      type: String,
      required: true
    },
    info: [String, Number]
  }
};
</script>
